"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var propTypes = {
  // Children elements
  children: _propTypes.node,
  // Description text usually a text, but can be a React component
  description: _propTypes.node,
  // description font
  descriptionFont: _utils.fontPropType,
  // Alignment for text
  textAlign: _propTypes.string,
  // title text usually a text, but can be a React component
  title: _propTypes.node,
  // title text font
  titleFont: _utils.fontPropType
};
var defaultProps = {
  descriptionFont: {
    fontSize: [2, 3],
    fontWeight: 1
  },
  titleFont: {
    fontSize: [3, 4, 5],
    fontWeight: 2
  }
};

var FlexibleText = function FlexibleText(_ref) {
  var title = _ref.title,
      description = _ref.description,
      titleFont = _ref.titleFont,
      descriptionFont = _ref.descriptionFont,
      textAlign = _ref.textAlign,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, null, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    mb: 1,
    tag: "h2",
    textAlign: textAlign
  }, titleFont), title), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    lineHeight: 1,
    textAlign: textAlign
  }, descriptionFont), description), children);
};

FlexibleText.propTypes = propTypes;
FlexibleText.defaultProps = defaultProps;
FlexibleText.displayName = "Modules.FlexibleText";
var _default = FlexibleText;
exports["default"] = _default;